import type { PosReportType } from '~/modules/staff/domain/pos-report.types'

export interface PosReportNavigationDefinition {
  type: PosReportType
  path: string
  icon: string
}

export const POS_REPORT_NAVIGATION: readonly PosReportNavigationDefinition[] = [
  { type: 'sales', path: '/staff/pos-reports/sales', icon: 'i-lucide-chart-column' },
  { type: 'collections', path: '/staff/pos-reports/collections', icon: 'i-lucide-hand-coins' },
  { type: 'cash', path: '/staff/pos-reports/cash', icon: 'i-lucide-calculator' },
  { type: 'adjustments', path: '/staff/pos-reports/adjustments', icon: 'i-lucide-file-minus-2' }
]

export function resolvePosReportType(value: unknown): PosReportType | null {
  if (typeof value !== 'string') return null
  return POS_REPORT_NAVIGATION.find(report => report.type === value)?.type ?? null
}
